import React, { useEffect, useState, Fragment, useCallback } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
// import GroupTitle from '../../../../Layout/AppMain/GroupTitle';
import GroupTitle from './GroupTitle/index';
import ButtonGroupTopActions from '../../../../Layout/AppMain/ButtonGroupTopActions';
import ButtonGroupStatusFilter from '../../../../Layout/AppMain/ButtonGroupStatusFilter';
import ButtonGroupStatusFilterReceivers from './ReceiversList/ButtonGroupStatusFilter';
import ButtonGroupStatusFilterCoordinators from './CoordinatorsList/ButtonGroupStatusFIlter';
import ModalAddUser from '../../../../Layout/AppMain/ModalAddUser';
import { useForm } from 'react-hook-form';
import api from '../../../../services/api';
import Coordinators from './CoordinatorsList/index';
import Receivers from './ReceiversList/index';
import Givers from './GiversList/index';
import { TabContent, TabPane, Row, Col, Card, Button } from 'reactstrap';
import { Elastic } from 'react-burgers';
import classnames from 'classnames';
import cx from 'classnames';
import * as Yup from 'yup';
import UserRoles from '../../../../enums/UserRoles';
import UserInviteLabels from '../../../../enums/UserInviteLabels';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../Context/Auth/AuthContext';

import Calendar from './Calendar/index';
import Needs from './NeedsList';
import MaterialsList from '../../../../Layout/AppMain/MaterialsList';
import GiftsList from './PlanList/index';
import GroupInfo from '../../../../Layout/AppMain/GroupInfo';
import Notes from './NotesList/index';
import AddNotes from '../../../../Layout/AppMain/AddNotes';
import AddNeeds from '../../../../Layout/AppMain/AddNeeds';
import Resources from '../../../../Layout/AppMain/Resources';

const schema = Yup.object().shape({
    // email: Yup.string().email('Email invalid!').required('Email is required!'),
    name: Yup.string().required('Name is required!'),
    phone: Yup.string().required('Phone is required!'),
});

export default function CoordinatorsDetails({ id }) {
    const { toggleLoading, currentGroup } = useAuth();
    const [group, setGroup] = useState({});
    const [newUser, setNewUser] = useState(null);
    const [refreshNote, setRefreshNote] = useState(false);
    const [refreshNeed, setRefreshNeed] = useState(false);
    const [groupId] = useState({ id: id });
    const [activeTab, setActiveTab] = useState('5');
    const [active, setActive] = useState(false);
    const { register, handleSubmit, errors, reset } = useForm({
        validationSchema: schema,
    });

    const [modalAddUser, setModalAddUser] = useState(false);
    const [modalAddUserTitle, setModalAddUserTitle] = useState(
        UserInviteLabels.COORDINATOR
    );
    const [typeAddUser, setTypeAddUser] = useState(UserRoles.COORDINATOR);
    const [modalIsReceiver, setModalIsReceiver] = useState(false);
    const [isAddingUser, setIstAddingUser] = useState(false);
    const [emailError, setEmailError] = useState();
    const [phoneError, setPhoneError] = useState();

    const defaultStatusFilter = { id : 'ACTIVE', label: 'Active' };
    const [currentStatusFilter, setCurrentStatusFilter] = useState(defaultStatusFilter);
    const [refreshLoading, setRefreshLoading] = useState(false);
    const [role] = useState(localStorage.getItem('@Reachout:groupRole'));

    const [receivers, setReceivers] = useState([]);
    const [givers, setGivers] = useState([]);

    const getGroup = useCallback(() => {
        setRefreshLoading(true);
        toggleLoading(true);
        api.get(`/ro.team.getGroup/${id}`)
            .then((response) => {
                setGroup(response.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                setRefreshLoading(false);
                toggleLoading(false);
            });
    }, [setRefreshLoading, toggleLoading, id]);

    useEffect(() => {
        getGroup();

        api.post(`/ro.team.listReceiversGroup/${id}`)
            .then((response) => {
                setReceivers(response.data.items);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
        
        api.post(`/ro.team.listGiversGroup/${id}`)
            .then((response) => {
                setGivers(response.data.items);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    }, [getGroup, setReceivers, id, setGivers]);

    const toggleStatusFilter = useCallback(
        (status) => {
            if (status === null) {
                setCurrentStatusFilter(defaultStatusFilter);
            } else {
                setCurrentStatusFilter(status);
            }
        },
        [setCurrentStatusFilter, defaultStatusFilter]
    );

    const toggle = useCallback(
        async (value) => {
            if (active) {
                setActive(!active);
            }
            setActiveTab(value);
            toggleStatusFilter(null);
        },
        [setActiveTab, toggleStatusFilter, active, setActive]
    );

    const toggleModalAddUser = useCallback(() => {
        setModalAddUser(!modalAddUser);
    }, [modalAddUser, setModalAddUser]);

    const toggleModalAddUserCoordinator = useCallback(() => {
        setModalAddUserTitle(UserInviteLabels.COORDINATOR);
        setTypeAddUser(UserRoles.COORDINATOR);
        setModalAddUser(!modalAddUser);
        setModalIsReceiver(false);
    }, [modalAddUser, setModalAddUser, setModalIsReceiver]);

    const toggleModalAddUserGiver = useCallback(() => {
        setModalAddUserTitle(UserInviteLabels.GIVER);
        setTypeAddUser(UserRoles.GIVER);
        setModalAddUser(!modalAddUser);
        setModalIsReceiver(false);
    }, [modalAddUser, setModalAddUser, setModalIsReceiver]);

    const toggleModalAddUserReceiver = useCallback(() => {
        setModalAddUserTitle(UserInviteLabels.RECEIVER);
        setTypeAddUser(UserRoles.RECEIVER);
        setModalAddUser(!modalAddUser);
        setModalIsReceiver(true);
    }, [modalAddUser, setModalAddUser, setModalIsReceiver]);

    const toggleCalendar = useCallback(
        (value) => {
            setActiveTab(value);
        },
        [setActiveTab]
    );

    const refreshGroup = useCallback(() => {
        getGroup();

        let role;
        switch (activeTab) {
            case '1':
                role = UserRoles.COORDINATOR.toString();
                break;
            case '2':
                role = UserRoles.GIVER.toString();
                break;
            case '3':
                role = UserRoles.RECEIVER.toString();
                break;
            default:
                role = null;
                break;
        }

        setNewUser(null);
        setNewUser(role);
    }, [getGroup, setNewUser, activeTab]);

    const checkPhoneNumber = useCallback((phone) => {
        let numberCount = 0;
        const map = Array.prototype.map

        map.call(phone, letter => {
            if (/^\d+$/.test(letter)) {
                numberCount++
            }
        });

        return (numberCount === 10) ? true : false;
    }, []);

    const onSubmitInvite = useCallback(
        async (data) => {
            toggleLoading(true);
            setIstAddingUser(true);
            const { email, name, phone, type } = data;
            let { noemail } = data;

            let endpoint;
            let success_message;
            let role;

            switch (type) {
                case JSON.stringify(UserRoles.COORDINATOR):
                    endpoint = 'ro.team.inviteCoordinatorGroup';
                    success_message = 'User was invited as coordinator!';
                    role = UserRoles.COORDINATOR;
                    break;
                case JSON.stringify(UserRoles.GIVER):
                    endpoint = 'ro.team.inviteGiverGroup';
                    success_message = 'User was invited as volunteer!';
                    role = UserRoles.GIVER;
                    break;
                case JSON.stringify(UserRoles.RECEIVER):
                    endpoint = 'ro.team.inviteReceiverGroup';
                    success_message = 'User was included as participant!';
                    role = UserRoles.RECEIVER;
                    break;
                default:
                    endpoint = '';
                    success_message = '';
                    break;
            }

            if (!checkPhoneNumber(phone)) {
                setPhoneError('Enter a valid phone');
                toggleLoading(false);
                setIstAddingUser(false);
                return;
            }

            if (noemail === undefined) {
                noemail = false;
            }
            
            if (noemail === false && !email && type === JSON.stringify(UserRoles.RECEIVER)) {
                setEmailError('Enter an email addres is required or select no email');
                toggleLoading(false);
                setIstAddingUser(false);
                return;
            }
            if (noemail === false && !email) {
                setEmailError('Email is required');
                toggleLoading(false);
                setIstAddingUser(false);
                return;
            }
            
            setPhoneError();
            setEmailError();

            api.post(endpoint, {
                email,
                name,
                phone,
                gid: id,
                noemail
            })
                .then((response) => {
                    toast.success(success_message);
                    reset(response);
                    toggleModalAddUser();
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    getGroup();
                    setNewUser(null);
                    setNewUser(role);
                    toggleLoading(false);
                    setIstAddingUser(false);
                });
        },
        [id, reset, getGroup, toggleModalAddUser, toggleLoading, setIstAddingUser, setEmailError, setPhoneError, checkPhoneNumber]
    );

    const checkRole = (panel) => {
        const permissions = [
            { panel: 'materials_admin', roles: ['owner', 'coordinator'] },
            { panel: 'group_info_admin', roles: ['owner', 'coordinator'] },
            { panel: 'transfer_group', roles: ['owner'] },
            { panel: 'add_coordinator', roles: ['owner'] },
        ];
        let result = false;
        // eslint-disable-next-line
        permissions.map((permission) => {
            if (permission.panel === panel) {
                // eslint-disable-next-line
                permission.roles.map((item) => {
                    if (item === role.replace(new RegExp('"', 'g'), '')) {
                        result = true;
                    }
                });
            }
        });

        return result;
    };

    const checkIsGroupOwner = useCallback(() => {
        let isOwner = false;

        if(currentGroup) {    
            currentGroup.roles.map((role) => {
                if (role.code === 4) {
                    isOwner = true;
                }
                return true;
            });
        }

        return isOwner;
    }, [currentGroup]);

    return (
        <Fragment>
            <CSSTransitionGroup
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <GroupTitle
                    heading={group.title}
                    subheading={group.description}
                    organization={group.organization}
                    icon="pe-7s-users fontWeigth800"
                    role={JSON.parse(role)}
                    groupId={groupId.id}
                    showLogs={true}
                />
            </CSSTransitionGroup>

            <CSSTransitionGroup
                className={cx('app-inner-layout chat-layout', {
                    'open-mobile-menu': active,
                })}
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <div>
                    <div className="app-inner-layout__wrapper row-fluid no-gutters">
                        <Card className="app-inner-layout__sidebar bg-transparent">
                            <div className="p-3">
                                <div className="dropdown-menu p-0 dropdown-menu-inline dropdown-menu-rounded dropdown-menu-hover-primary">
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '5',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('5');
                                        }}
                                    >
                                        Group Info
                                    </Button>
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '1',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('1');
                                        }}
                                    >
                                        Coordinators
                                    </Button>

                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '2',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('2');
                                        }}
                                    >
                                        Volunteers
                                    </Button>
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '3',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('3');
                                        }}
                                    >
                                        Seniors
                                    </Button>

                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '4',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('4');
                                        }}
                                    >
                                        Group Schedule
                                    </Button>
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '7',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('7');
                                        }}
                                    >
                                        Needs
                                    </Button>
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '8',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('8');
                                        }}
                                    >
                                        Notes
                                    </Button>
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '9',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('9');
                                        }}
                                    >
                                        Resources
                                    </Button>
                                </div>
                            </div>
                        </Card>
                        <Card className="col-md-12 app-inner-layout__content">
                            <div className="pb-5 pl-2 pr-2 pt-3">
                                <div className="mobile-app-menu-btn mb-3">
                                    <Elastic
                                        width={26}
                                        lineHeight={2}
                                        lineSpacing={5}
                                        color="#6c757d"
                                        active={active}
                                        onClick={() => setActive(!active)}
                                    />
                                </div>

                                <ModalAddUser
                                    modalAddUser={modalAddUser}
                                    toggleModalAddUser={toggleModalAddUser}
                                    modalAddUserTitle={modalAddUserTitle}
                                    register={register}
                                    errors={errors}
                                    type={typeAddUser}
                                    handleSubmit={handleSubmit}
                                    onSubmitInvite={onSubmitInvite}
                                    isReceiver={modalIsReceiver}
                                    emailError={emailError}
                                    phoneError={phoneError}
                                    isAddingUser={isAddingUser}
                                />

                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Coordinators</h4>
                                                <ButtonGroupStatusFilterCoordinators
                                                    showFilter={true}
                                                    status={currentStatusFilter}
                                                    callback={
                                                        toggleStatusFilter
                                                    }
                                                />
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <ButtonGroupTopActions
                                                    showRefreshBtn={true}
                                                    showAddBtn={checkRole('add_coordinator') || checkIsGroupOwner()}
                                                    refreshLoading={
                                                        refreshLoading
                                                    }
                                                    refreshCallback={
                                                        refreshGroup
                                                    }
                                                    addCallback={
                                                        toggleModalAddUserCoordinator
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                        <div className="divider" />
                                        <Coordinators
                                            id={groupId}
                                            activeTab={activeTab}
                                            filter={currentStatusFilter}
                                            newUser={newUser}
                                        />
                                    </TabPane>

                                    <TabPane tabId="2">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Volunteers</h4>
                                                <ButtonGroupStatusFilter
                                                    showFilter={true}
                                                    status={currentStatusFilter}
                                                    callback={
                                                        toggleStatusFilter
                                                    }
                                                />
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <ButtonGroupTopActions
                                                    showRefreshBtn={true}
                                                    showAddBtn={true}
                                                    refreshLoading={
                                                        refreshLoading
                                                    }
                                                    refreshCallback={
                                                        refreshGroup
                                                    }
                                                    addCallback={
                                                        toggleModalAddUserGiver
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                        <div className="divider" />
                                        <Givers
                                            id={groupId}
                                            activeTab={activeTab}
                                            filter={currentStatusFilter}
                                            newUser={newUser}
                                            toggleCalendar={toggleCalendar}
                                        />
                                    </TabPane>

                                    <TabPane tabId="3">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Seniors</h4>
                                                <ButtonGroupStatusFilterReceivers
                                                    showFilter={true}
                                                    status={currentStatusFilter}
                                                    callback={
                                                        toggleStatusFilter
                                                    }
                                                />
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <ButtonGroupTopActions
                                                    showRefreshBtn={true}
                                                    showAddBtn={true}
                                                    refreshLoading={
                                                        refreshLoading
                                                    }
                                                    refreshCallback={
                                                        refreshGroup
                                                    }
                                                    addCallback={
                                                        toggleModalAddUserReceiver
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                        <div className="divider" />
                                        <Receivers
                                            id={groupId}
                                            activeTab={activeTab}
                                            filter={currentStatusFilter}
                                            newUser={newUser}
                                            role={role}
                                        />
                                    </TabPane>

                                    <TabPane tabId="4">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Group Calendar</h4>
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <Button
                                                    className="mb-2 mr-2 btn-icon btn-icon-only"
                                                    color="success"
                                                    onClick={() =>
                                                        toggleCalendar('41')
                                                    }
                                                >
                                                    Group Call Plan
                                                </Button>
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <Calendar
                                            receivers={receivers}
                                            activeTab={activeTab}
                                            givers={givers}
                                        />

                                        <div className="mt-5" />
                                    </TabPane>

                                    <TabPane tabId="41">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Group Call Plan</h4>
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <Button
                                                    className="mb-2 mr-2 btn-icon btn-icon-only"
                                                    color="success"
                                                    onClick={() =>
                                                        toggleCalendar('4')
                                                    }
                                                >
                                                    Group Calendar
                                                </Button>
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <GiftsList
                                            givers={givers}
                                        />

                                        <div className="mt-5" />
                                    </TabPane>

                                    <TabPane tabId="5">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Group Info</h4>
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <ButtonGroupTopActions
                                                    showRefreshBtn={true}
                                                    showAddBtn={false}
                                                    refreshCallback={getGroup}
                                                />
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <GroupInfo
                                            group={group}
                                            admin={checkRole('group_info_admin') || checkIsGroupOwner()}
                                            owner={checkRole('transfer_group') || checkIsGroupOwner()}
                                        />

                                        <MaterialsList
                                            id={groupId}
                                            admin={checkRole('materials_admin')}
                                        />

                                        <div className="mt-5" />
                                    </TabPane>

                                    <TabPane tabId="7">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Needs</h4>
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <AddNeeds
                                                    id={groupId}
                                                    receivers={receivers}
                                                    setRefreshNeed={setRefreshNeed}
                                                />
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <Needs
                                            role={JSON.parse(role)}
                                            activeTab={activeTab}
                                            refreshNeed={refreshNeed}
                                            setRefreshNeed={setRefreshNeed}
                                        />

                                        <div className="mt-5" />
                                    </TabPane>

                                    <TabPane tabId="8">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Notes</h4>
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <AddNotes
                                                    id={groupId}
                                                    setRefreshNote={setRefreshNote}
                                                />
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <Notes
                                            id={groupId}
                                            refreshNote={refreshNote}
                                            setRefreshNote={setRefreshNote}
                                        />

                                        <div className="mt-5" />
                                    </TabPane>

                                    <TabPane tabId="9">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Resources</h4>
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <Resources />

                                    </TabPane>

                                </TabContent>
                            </div>
                        </Card>
                    </div>
                </div>
            </CSSTransitionGroup>
        </Fragment>
    );
}
